/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SelectedOfferType {
    CASH = 'Cash',
    STORE_CREDIT = 'StoreCredit',
}
